import fetch from '@/config/fetch';
import fetchNew from '@/config/fetchNew';


export const updatePersonnel = (data) => fetch('/platform/othercost/updatePersonnel', data, 'POST');
export const updatePersonneli = (data) => fetch('/platform/deductionInvoicingCost/updatePersonnel', data, 'POST');

/**
 * 合同类型配置
 */
// 分页
export const contractTypePageList = (data) => fetch('/platform/contractType/pageList', data, 'POST');
// 修改
export const contractTypeUpdate = (data) => fetch('/platform/contractType/update', data, 'POST');
// 新增
export const contractTypeAdd = (data) => fetch('/platform/contractType/add', data, 'POST');
//启用禁用
export const contractTypeIsEnable = (id) => fetch(`/platform/contractType/isEnable/${id}`, {}, 'POST');
//删除
export const contractTypeDelete = (id) => fetch(`/platform/contractType/delete/${id}`, {}, 'POST');

/**
 * 价格评审
 */
// 分页
export const priceReviewPageList = (data) => fetch('/platform/busi/priceReview/pageList', data, 'POST');
// 修改
export const priceReviewUpdate = (data) => fetch('/platform/busi/priceReview/update', data, 'POST');
// 新增
export const priceReviewAdd = (data) => fetch('/platform/busi/priceReview/add', data, 'POST');
//详情查询
export const priceReviewDetail = (id) => fetch('/platform/busi/priceReview/detail', id, 'GET');
//取消申请
export const priceReviewCancelApplyFor = (id) => fetch('/platform/busi/priceReview/cancelApplyFor', id, 'GET');

/**
 * 日常考核
 */
// 分页
export const dailyReviewPageList = (data) => fetch('/platform/busi/dailyReview/pageList', data, 'POST');
// 修改
export const dailyReviewUpdate = (data) => fetch('/platform/busi/dailyReview/update', data, 'POST');
// 新增
export const dailyReviewAdd = (data) => fetch('/platform/busi/dailyReview/add', data, 'POST');
//详情查询
export const dailyReviewDetail = (id) => fetch('/platform/busi/dailyReview/detail', id, 'GET');
//取消申请
export const dailyReviewCancelApplyFor = (id) => fetch('/platform/busi/dailyReview/cancelApplyFor', id, 'GET');
// /platform/sys/supplierPortOther/selectList
//港口及其他下拉框数据

/**
 * 培训记录
 */
// 分页
export const trainRecordPageList = (data) => fetch('/platform/busi/trainRecord/pageList', data, 'POST');
// 修改
export const trainRecordUpdate = (data) => fetch('/platform/busi/trainRecord/update', data, 'POST');
// 新增
export const trainRecordAdd = (data) => fetch('/platform/busi/trainRecord/add', data, 'POST');
//详情查询
export const trainRecordDetail = (id) => fetch('/platform/busi/trainRecord/detail', id, 'GET');
//取消申请
export const trainRecordCancelApplyFor = (id) => fetch('/platform/busi/trainRecord/cancelApplyFor', id, 'GET');
//培训参与者
export const trainParticipatorSelectList = (data) => fetch('/platform/busi/trainParticipator/selectList', data, 'POST');
//培训参与者  新增按钮
export const trainParticipatorAdd = (data) => fetch('/platform/busi/trainParticipator/add', data, 'POST');
//培训参与者  删除按钮
export const trainParticipatorDelete = (id) => fetch(`/platform/busi/trainParticipator/delete/${id}`, {}, 'POST');

/**
 * 合同列表
 */
// 分页

export const contractPageList = (data) => fetch('/platform/contractAffairs/pageList', data, 'GET');
//合同列表下拉框
export const contractSelectPageList = (data) => fetch('/platform/contractAffairs/getByCompanyId', data, 'GET');

// 修改
export const contractUpdate = (data) => fetch('/platform/contractAffairs/update', data, 'POST');
// 新增
export const contractAdd = (data) => fetch('/platform/contractAffairs/add', data, 'POST');
// 变更
export const contractChange = (data) => fetch('/platform/contractAffairs/change', data, 'POST');
// 终止
export const contractStop = (id) => fetch(`/platform/contractAffairs/stop/${id}`, {}, 'POST');
//详情查询
export const contractDetail = (id) => fetch('/platform/contractAffairs/detail', { 'id': id }, 'GET');
//状态修改
export const contractUpdateStatus = (id, data) => fetch(`/platform/contractAffairs/updateStatus/${id}`, data, 'POST');
//签约单位
export const contractGetContractType = (flag) => fetch(`/platform/vehicle-deploy-car-cv/getContractType/${flag}`, {}, 'GET');
//履约保证金添加
export const contractAddBond = (data) => fetch('/platform/contractAffairs/addBond', data, 'POST');
//合同删除
export const deleteContract = (id) => fetch(`/platform/contractAffairs/deleteContract/${id}`, {}, 'POST');
//合同启用
export const enableContract = (id) => fetch(`/platform/contractAffairs/enableContract?id=${id}`, {}, 'GET');
//合同预警
export const contractWarningPage = (data) => fetch('/platform/contractAffairs/contractWarningPage', data, 'GET');

//合同类型下拉框
export const contractTypeSelectList = (data) => fetch('/platform/contractType/selectList', data, 'GET');
//主合同下拉框
export const contractIdSelectList = (data) => fetch('/platform/contractAffairs/change', data, 'GET');

/**
 *其他费用
 * @param data
 * */
// 其他费用分页查询
export const otherExpenses = (data) => fetch('/platform/othercost/pageList', data, 'GET');
// 其他费用-生成台账
export const generateAccount = (data) => fetch('/platform/otherCost/standingBook/generateAccount', data, 'POST');
// 其他费用审核查询
export const otherAudit = (data) => fetch('/platform/othercost/auditPageList', data, 'GET');
// 新增
export const othernewInvoice = (data) => fetch('/platform/othercost/insert', data, 'POST');
// 修改
export const otherinvoicingModification = (data) => fetch('/platform/othercost/update', data, 'POST');
// 审核
export const toExamine = (data) => fetch('/platform/othercost/auditPageList', data, 'GET');
//添加合同-查询
export const getContract = (data) => fetch('/platform/othercost/getContract', data, 'GET');
// 取消审核
export const cancelAudit = (id) => fetch(`/platform/othercost/cancelApplyFor/${id}`, {}, 'POST');
// 删除
export const delOtherNew = (id) => fetch(`/platform/othercost/delete/${id}`, {}, 'POST');
//取消对账
export const cancelRefer = (id) => fetch(`/platform/othercost/cancel/${id}`, {}, 'POST');
// 详情
export const detailList = (id) => fetch(`/platform/othercost/detail/${id}`, {}, 'GET');
// 重新提交
export const againOtherNew = (id) => fetch(`/platform/othercost/resubmit/${id}`, {}, 'POST');
// 通过编码查询下拉字典表数据
export const feeId = (data) => fetch('/platform/paramCategoryAttr/selectCategoryAttr', data, 'GET');
//提交对账-查询
export const getReconciliation = (data) => fetch('/platform/othercost/getReconciliation', data, 'GET');
//提交对账-确认
export let settlementId = (otherId, settId) => fetch(`/platform/othercost/mergeReconciliation/${otherId}/${settId}`, {},'POST');
//生成对账单
export const elseAdd = data => fetch('/platform/customer/account/add', data, 'POST');
//添加台账月
export const addStandingBookMonth = (data) => fetch('/platform/othercost/addStandingBookMonth', data, 'GET');
export const updateStandingBookMonth = (data) => fetch('/platform/deductionInvoicingCost/updateStandingBookMonth', data, 'GET');
//添加附件
export const addAttachment = (data) => fetch('/platform/othercost/addAttachment', data, 'POST');

/**
 *抵扣开票费用
 * @param data
 */
// 抵扣开票费用 -- 分页查询
export const discountPagination = (data) => fetch('/platform/deductionInvoicingCost/pageList', data, 'GET');
// 折扣发票 -- 新增
export const newInvoice = (data) => fetch('/platform/deductionInvoicingCost/add', data, 'POST');
// 折扣开票 -- 删除
export const invoicingDelete = (id) => fetch(`/platform/deductionInvoicingCost//delete/${id}`, {}, 'POST');
// 折扣开票 -- 修改
export const invoicingModification = (data) => fetch('/platform/deductionInvoicingCost/update', data, 'POST');
// 折扣开票 -- 查看详情
export const viewDetails = (id) => fetch(`/platform/deductionInvoicingCost/detail/${id}`, {}, 'GET');
// 取消审核
export const cancelDiscount = (id) => fetch(`/platform/deductionInvoicingCost/cancelApplyFor/${id}`, {}, 'POST');
// 重新提交
export const againDiscount = (id) => fetch(`/platform/deductionInvoicingCost/resubmit/${id}`, {}, 'POST');
//提交对账
// eslint-disable-next-line no-shadow
export let SubmitReconciliation = (deductId,settlementId) => fetchNew(`/deductionInvoicingCost/mergeReconciliation/${deductId}/${settlementId}`, {},'POST');
//取消对账
export const cancelSubmit= (id) => fetchNew(`/deductionInvoicingCost/cancel/${id}`, {}, 'POST');

/**
 *油价费用
 * @param data
 */
//查询
export const getPage = (data) => fetch('/platform/oilPriceCost/getPage', data, 'GET');
//分页查询
export const getPageList = (id) => fetch('/platform/oilPriceCost/getPageSet', id, 'GET');
//详情
export const getDetail = (id) => fetch('/platform/oilPriceCost/detail', id, 'GET');
//修改
export const oilEdit = (data)=> fetch(`/platform/oilPriceCost/edit?id=${data.id}&title=${data.title}`, {}, 'POST');
//删除
export const oilDelete = (data) => fetch('/platform/oilPriceCost/delete', data, 'POST');
//取消对账
export const cancelReconciliation = (id) => fetch(`/platform/oilPriceCost/cancel/${id}`, {}, 'POST');

//提交对账-查询
export const getReconciliationList = (data) => fetch('/platform/oilPriceCost/getReconciliation', data, 'GET');
//提交对账
// eslint-disable-next-line no-shadow
export let mergeReconciliation = (oilId, settlementId) => fetch(`/platform/oilPriceCost/mergeReconciliation/${oilId}/${settlementId}`, {},'POST');

export let cancelDiscounExpenses = (data) => fetchNew('/deductionInvoicingCost/cancelDiscount', data,'POST');
